module.exports = __webpack_public_path__ + "img/wedss3.28a9f5d3.jpg";